module.exports = __webpack_public_path__ + "img/home-5.2802e2e2.png";